<div *ngIf="(pageVm$ | async) as pageVm">

  <app-page-header [vm]="pageVm" title='Chauffeur HR' [fullHeader]="true">
  </app-page-header>

  <div *ngIf="pageVm.contentVm as vm" class="pt-2">
    <div class="row">
      <div class="col-md-12">

        <!-- links -->
        <div class="d-flex flex-row">
          <div *ngFor="let a of vm.actions" class="pr-3">
            <a mdbBtn size="sm" gradient="blue" mdbWavesEffect
              (click)="invokeAction(pageVm, vm, a)"
              >{{a.title}}</a>
          </div>
        </div>

        <div *ngIf="vm.frameVm.loading">
          <span>loading...</span>
        </div>

        <div *ngIf="vm.frameVm.unauthorized">
          <span>Unauthorized</span>
        </div>

        <div class="iframe-container">
          <iframe *ngIf="!vm.frameVm.unauthorized" frameborder="0" scrolling="yes" [src]="vm.frameVm.url" (load)="iframeLoad(vm)" class="iframe-content" allowfullscreen></iframe>
        </div>

      </div>
    </div>
  </div>

</div>
